module.exports = __webpack_public_path__ + "static/img/ins_img.386f8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ins_img.png
// module id = yrmu
// module chunks = 1